import { Component, Input, OnInit } from '@angular/core';
import { HisUiService, HisReorderTableService, HisTableConfigResults } from 'hisng';
import { ErpWorkflowService } from '../service/erpworkflow.service';
import { ErpWorkflowHistoryItem } from '../model/erpworkflowhistoryitem';
import { ErpWorkflowHistoryTableItem } from '../model/erpworkflowhistorytableitem';

@Component( {
    selector: 'erp-workflow-history',
    templateUrl: './erpworkflowhistory.component.html'
} )
export class ErpWorkflowHistoryComponent implements OnInit {
    @Input() processType = '';
    @Input() processId = 0;

    private static readonly LOCAL_STORAGE_WORKFLOW_HISTORY_TABLE_SETTING_COLUMNS_KEY = 'his_rm_erp_common_workflow_table_column_';
    private static readonly LOCAL_STORAGE_WORKFLOW_HISTORY_TABLE_SETTING_REORDERABLE_KEY = 'his_rm_erp_common_workflow_table_reorderable_';

    isReorderable = false;
    historyRows: any[] = [];
    historyColumns: any[] = [];
    selectableCols: any[] = [];

    constructor(
        private readonly hisUiService: HisUiService,
        private hisReorderTableService: HisReorderTableService,
        private readonly erpWorkflowService: ErpWorkflowService
    ) { }

    ngOnInit(): void {
        this.historyColumns = [
            { field: 'index', header: 'idx-h', title: 'rm.erp.common.workflow.history.index' },
            { field: 'executingPerson', header: 'execPers-h', title: 'rm.erp.common.workflow.history.executingPerson' },
            { field: 'processingStep', header: 'procStep-h', title: 'rm.erp.common.workflow.history.processingStep' },
            { field: 'executingDate', header: 'execDate-h', title: 'rm.erp.common.workflow.history.executingDate' },
            { field: 'nextResponsiblePerson', header: 'respPers-h', title: 'rm.erp.common.workflow.history.nextResponsiblePerson' },
            { field: 'nextResponsiblePersonEmail', header: 'reMail-h', title: 'rm.erp.common.workflow.history.nextResponsiblePersonEmail' },
            { field: 'comment', header: 'comment-h', title: 'rm.erp.common.workflow.history.comment' },
        ];
        this.selectableCols = this.historyColumns;
        this.loadTableSettingsFromLocalStorage();
        this.loadHistory();
    }

    loadHistory(): void {
        this.erpWorkflowService.loadHistory(this.processType, this.processId)
            .subscribe( {
                next: ( historyList ) => {
                    this.fillTableData(historyList);
                }
            } );
    }

    clearHistory(): void {
        this.historyRows = [];
    }

    refreshTableColumns( tableColumns: HisTableConfigResults ) {
        this.historyColumns = tableColumns.columResults;
        this.isReorderable = tableColumns.isReorderable;
        this.saveTableSettingsToLocalStorage();
    }

    moveTableColumn( columns: any[], col: any, direction: number ) {
        this.hisReorderTableService.moveRowOrColumn(columns, col, direction);
    }

    private fillTableData(historyList: ErpWorkflowHistoryItem[]): void {
        historyList.forEach((listItem: ErpWorkflowHistoryItem, idx: number) => {
            let execPerson = '';
            if (listItem.isExecutedBySystem) {
                execPerson = this.hisUiService.translate( 'rm.erp.common.workflow.system' );
            } else if (!listItem.isExecutedBySystem && listItem.executingPersonSurname) {
                execPerson = [listItem.executingPersonSurname, listItem.executingPersonFirstname].join(', ');
            }

            const history: ErpWorkflowHistoryTableItem = {
                // Nummer
                index: idx + 1,
                // Ausgeführt durch
                executingPerson: execPerson,
                // Bearbeitungsschritt
                processingStep: listItem.processingStepText,
                // Datum
                executingDate: listItem.editTimestamp,
                // Nächste Zuständigkeit
                nextResponsiblePerson: [listItem.nextResponsiblePersonSurname,
                    listItem.nextResponsiblePersonFirstname].filter(Boolean).join(', '),
                // E-Mail an
                nextResponsiblePersonEmail: listItem.responsiblePersonEmail,
                // Kommentar42
                comment: listItem.comment
            };

            this.historyRows.push(history);
        });
    }

    private saveTableSettingsToLocalStorage(): void {
        const keyCol = ErpWorkflowHistoryComponent.LOCAL_STORAGE_WORKFLOW_HISTORY_TABLE_SETTING_COLUMNS_KEY + this.processType;
        const columns = JSON.stringify( this.historyColumns );
        localStorage.setItem( keyCol, columns );

        const keyReord = ErpWorkflowHistoryComponent.LOCAL_STORAGE_WORKFLOW_HISTORY_TABLE_SETTING_REORDERABLE_KEY + this.processType;
        const isReord = JSON.stringify( this.isReorderable );
        localStorage.setItem( keyReord, isReord );
    }

    private loadTableSettingsFromLocalStorage(): void {
        const keyCol = ErpWorkflowHistoryComponent.LOCAL_STORAGE_WORKFLOW_HISTORY_TABLE_SETTING_COLUMNS_KEY + this.processType;
        const itemCol = localStorage.getItem( keyCol );

        const keyReord = ErpWorkflowHistoryComponent.LOCAL_STORAGE_WORKFLOW_HISTORY_TABLE_SETTING_REORDERABLE_KEY + this.processType;
        const itemReord = localStorage.getItem( keyReord );

        if ( itemCol != null && itemReord != null ) {
            this.historyColumns = JSON.parse( itemCol );
            this.isReorderable = JSON.parse( itemReord );
        }
    }
}
